import { VideoColorFinderJob } from "@nova/protobuf"
import { entityValidator, enumValidator, UnionToTuple } from "../util"
import { JobStatusType } from "@nova/constants"
import { dateAsNumber } from "../../util"

export const createVideoColorFinderJobValidator = entityValidator(VideoColorFinderJob, {
    srtPath: {
        validators: [],
    },
    videoPath: {
        validators: [],
        nonNull: true,
    },
    colordataPath: {
        validators: [],
        nonNull: true,
    },
    metadataPath: {
        validators: [],
    },
    numFrames: {
        validators: [],
    },
    cumulativeColorIndex: {
        validators: [],
        nonNull: true,
    },
    anomalyPath: {
        nonNull: true,
        validators: [],
    },
})

export const updateVideoColorFinderJobValidator = entityValidator(VideoColorFinderJob, {
    status: {
        validators: enumValidator("status", JobStatusType),
        nonNull: true,
    },
    resolutions: {
        validators: [],
        nonNull: true,
    },
})

export const getDefaultVideoColorFinderJobCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.COMPLETED,
    resolutions: [],
})

export type CreateVideoColorFinderJobArgs = UnionToTuple<
    keyof typeof createVideoColorFinderJobValidator
>
export type UpdateVideoColorFinderJobArgs = UnionToTuple<
    keyof typeof updateVideoColorFinderJobValidator
>
